export default {
    SELECTED_ADDRESS: "SELECTED_ADDRESS",
}